import type { PropsWithChildren } from 'react';
import { useDisplayInSchedule } from '@elfsight/widget-conditional-display';
import { useSettings } from '@wu/widget-core';

export const MatchSchedule = ({ children }: PropsWithChildren) => {
  const { editMode, schedule, ...settings } = useSettings();
  const display = useDisplayInSchedule({ settings, enabled: schedule });

  if (!editMode && !display) {
    return null;
  }

  return children;
};
